module.exports = __webpack_public_path__ + "img/logo_animation.4d6336f6.gif";